<!-- 销售包详情（基地经理） -->
<template>
  <div class="backgroundGrey base-padding">
    <div class="details-card">
      <div class="details-title">
        航班信息
      </div>
      <div class="detailsItem">
        <div v-if="[1,2,3,4,5].includes(main.state)">
          <span>航班日期：</span>
          <span>{{ main.flightDateDesc }}</span>
        </div>
        <div v-if="[1,3,4,5].includes(main.state)">
          <span>航线环：</span>
          <span>{{ main.flightNoRing }}</span>
        </div>
        <div v-if="[2].includes(main.state)">
          <span>航班环：</span>
          <span>{{ main.flightNoRing }}</span>
        </div>
        <div v-if="[1,2,3,4,5].includes(main.state)">
          <span>航段环：</span>
          <span>{{ main.flightLineRing }}</span>
        </div>
        <div v-if="[3,4,5].includes(main.state)">
          <span>领取人：</span>
          <span>{{ main.receiveStaffName }}</span>
        </div>
        <div v-if="[3,4,5].includes(main.state)">
          <span>领取时间：</span>
          <span>{{ main.receiveTime }}</span>
        </div>
        <div v-if="[4,5].includes(main.state)">
          <span>归还人：</span>
          <span>{{ main.returnStaffName }}</span>
        </div>
        <div v-if="[4,5].includes(main.state)">
          <span>归还时间：</span>
          <span>{{ main.returnTime }}</span>
        </div>
        <div>
          <span>状态：</span>
          <span>{{ main.stateDesc }}</span>
        </div>
      </div>
    </div>
    <div class="details-card" style="padding: 0;">
      <div class="sp-title">商品清单</div>
      <Grid :columns="columns" :tableData="main.bagProductSignList" style="margin: 0 1rem;" />
    </div>
    <div class="details-card" style="padding: 0" v-if="main.state === 1">
      <van-form>
        <van-field v-model="main.distributeSealNo" colon required label-width="140px" input-align="right" label="配出铅封号" placeholder="请输入配出铅封号" />
        <van-field v-model="main.sellPackageNo" colon required label-width="140px" input-align="right" label="销售包号" placeholder="请输入销售包号" />
        <van-field v-model="main.distributePackageCount" colon required label-width="140px" input-align="right" type="digit" label="配发销售包数量"
                   placeholder="请输入配发销售包数量" />
      </van-form>
    </div>
<!--    <div class="details-card" style="padding: 0" v-if="main.state === 4">
      <van-form>
        <van-field v-model="main.actualReturnSellPackageCount" colon label-width="140px" input-align="right" name="实际归还销售包数量" type="digit" label="实际归还销售包数量"
                   placeholder="请输入数量" />
      </van-form>
    </div>-->
    <div class="details-card" style="padding: 0" v-if="[1].includes(main.state)">
      <van-field v-model="main.remark" type="textarea" placeholder="请输入备注说明：" show-word-limit :maxlength="100" autosize label-width="0" />
    </div>
    <div class="details-card" v-if="[3, 4, 5].includes(main.state)">
      <div style="font-size: 14px;line-height: 40px;">上传图片</div>
      <img :src="item" alt="" v-for="(item,index) in main.imgFullUrlList" style="height: 80px;width: 80px;margin-right: 10px;" :key="index"
           @click="openImgs(item)">
    </div>

    <div class="details-card" v-if="[2].includes(main.state)">
      <div style="font-size: 14px;display: flex;padding: 10px 0;">
        <span>备注：</span>
        <span style="width:calc(100% - 80px)">{{ main.remark }}</span>
      </div>
    </div>
    <div class="details-card" v-if="[3, 4, 5].includes(main.state)">
      <div style="font-size: 14px;display: flex;padding: 10px 0;">
        <span>领取备注：</span>
        <span style="width:calc(100% - 80px)">{{ main.receiveRemark }}</span>
      </div>
    </div>
    <div class="details-card" v-if="[4, 5].includes(main.state)">
      <div style="font-size: 14px;display: flex;padding: 10px 0;">
        <span>归还备注：</span>
        <span style="width:calc(100% - 80px)">{{ main.returnRemark }}</span>
      </div>
    </div>
    <BottomButton v-if="main.state === 1">
      <van-button type="primary" @click="confirm">确认</van-button>
    </BottomButton>
    <BottomButton v-if="main.state === 4">
      <van-button type="primary" @click="confirmReturn">确认完成</van-button>
    </BottomButton>
  </div>

</template>

<script>
import EmptyTips from '@/components/common/EmptyTips'
import Grid from '@/components/common/Grid/index.vue'
import BottomButton from '@/components/common/BottomButton'

export default {
  components: {
    EmptyTips,
    Grid,
    BottomButton,
  },
  data() {
    return {
      main: {},
      username: '',
      applies: [],
      fileList: [],
      digit: '',
      detailsId: '',
    }
  },
  computed: {
    columns() {
      let arr = []
      // 已确认
      if ([1, 2].includes(this.main.state)) {
        arr = [
          { label: '商品名称', prop: 'productName' },
          { label: '单位', prop: 'basicUnitEnuName' },
          { label: '计划', prop: 'standardNum' },
          { label: '加配', prop: 'addNum', type: 'number' },
        ]
      }
      // 已领取
      if ([3].includes(this.main.state)) {
        arr = [
          { label: '商品名称', prop: 'productName' },
          { label: '单位', prop: 'basicUnitEnuName' },
          { label: '计划', prop: 'standardNum' },
          { label: '加配', prop: 'addNum', type: 'number' },
          { label: '实配', prop: 'actualNum' , type: 'number' },
        ]
      }
      // 已归还
      if ([4].includes(this.main.state)) {
        arr = [
          { label: '商品名称', prop: 'productName' },
          { label: '单位', prop: 'basicUnitEnuName' },
          { label: '计划', prop: 'standardNum' },
          { label: '加配', prop: 'addNum', type: 'number' },
          { label: '实配', prop: 'actualNum' , type: 'number' },
         /* { label: '应收', prop: 'actualRecoveryNum', type: 'number' },
          { label: '实收', prop: 'actualRecoveryNum', type: 'number' },*/
        ]
      }
      // 已完成
      if ([5].includes(this.main.state)) {
        arr = [
          { label: '商品名称', prop: 'productName' },
          { label: '单位', prop: 'basicUnitEnuName' },
          { label: '计划', prop: 'standardNum' },
          { label: '加配', prop: 'addNum', type: 'number' },
          { label: '实配', prop: 'actualNum' , type: 'number' },
        /*  { label: '回收', prop: 'recoveryNum' },
          { label: '实收', prop: 'actualRecoveryNum' },*/
        ]
      }
      return arr
    },
  },
  activated() {
    this.main = this.$route.query
    this.detailsId = this.$route.query.id
    this.getDetails()
  },
  methods: {
    openImgs(item) {
      this.$ImagePreview({
        images: [item],
        closeable: true,
      })
    },
    getDetails() {
      let _this = this
      this.$api.get('/api-sys/apiOverNightBag/getById?id=' + this.detailsId).then((res) => {
        if (res.code === '0000') {
          _this.main = res.data
          if (_this.main.state === 4) {
            _this.main.bagProductSignList.forEach((item) => {
              item.actualRecoveryNum = item.recoveryNum
            })
          }
          _this.main.distributePackageCount = _this.main.distributePackageCount || ''
          console.log(_this.main.distributePackageCount)
          if (_this.main.state === 4) {
            _this.main.actualReturnSellPackageCount = _this.main.returnSellPackageCount
          }
        }
      })
    },
    confirm() {
      if (!this.main.distributeSealNo) {
        this.$Toast('请输入配出铅封号')
        return
      }
      if (!this.main.sellPackageNo) {
        this.$Toast('请输入销售包号！')
        return
      }
      if (!this.main.distributePackageCount) {
        this.$Toast('请输入配发销售包数量！')
        return
      }
      let _this = this
      this.$Dialog
        .confirm({
          title: '标题',
          message: '是否确认？',
          messageAlign: 'left',
        })
        .then(() => {
          this.$api
            .post('/api-sys/apiOverNightBag/allotment', {
              id: _this.detailsId,
              ..._this.main,
            })
            .then((res) => {
              if (res.code === '0000') {
                this.$Toast.success('确认成功')
                setTimeout(() => {
                  this.$utils.routerPush({
                    name: 'OvernightBagManage',
                  })
                }, 700)
              }
            })
        })
        .catch(() => {
          // on cancel
        })
    },
    confirmReturn() {
      let _this = this
      this.$Dialog
        .confirm({
          title: '标题',
          message: '请确认回收铅封号是否一致，归还销售包数量是否正确？',
          messageAlign: 'left',
        })
        .then(() => {
          this.$api
            .post('/api-sys/apiOverNightBag/confirmedReturn', {
              id: _this.detailsId,
              actualReturnSellPackageCount: _this.main.actualReturnSellPackageCount,
              bagProductSignList: _this.main.bagProductSignList,
            })
            .then((res) => {
              if (res.code === '0000') {
                this.$Toast.success('操作成功')
                setTimeout(() => {
                  this.$utils.routerPush({
                    name: 'OvernightBagManage',
                  })
                }, 700)
              }
            })
        })
        .catch(() => {
          // on cancel
        })
    },
  },
}
</script>

<style lang="less" scoped>
.detailsItem {
  width: 100%;
  background: white;

  & > div {
    span {
      min-width: 120px;
      // line-height: 30px;
    }
  }
}
.sp-title {
  border-left: 6px solid #e1514c;
  border-bottom: 2px solid #e1514c;
  height: 24px;
  font-size: 14px;
  line-height: 24px;
  padding-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/view/OvernightBag/OvernightBagManageDetails.vue